import { Chip, Tooltip, Box, Typography } from "@mui/material";
import PercentIcon from "@mui/icons-material/Percent";

/**
 * Componente para mostrar indicador de cálculo proporcional en pre-distribuciones
 * @param {boolean} isProportional - Si el cálculo es proporcional (prorrateo)
 * @param {boolean} showTooltip - Si mostrar tooltip con explicación (default: true)
 * @param {boolean} showIcon - Si mostrar ícono en el chip (default: true)
 * @param {string} size - Tamaño del chip: "small" | "medium" (default: "small")
 */
const ProportionalCalculationIndicator = ({
  isProportional,
  showTooltip = true,
  showIcon = true,
  size = "small",
}) => {
  // Si no aplica prorrateo, no mostrar nada
  if (!isProportional) {
    return null;
  }

  // Chip básico
  const chipComponent = (
    <Chip
      label="Prorrateo"
      color="info"
      size={size}
      variant="outlined"
      icon={showIcon ? <PercentIcon /> : undefined}
    />
  );

  // Si no se debe mostrar tooltip, retornar solo el chip
  if (!showTooltip) {
    return chipComponent;
  }

  // Tooltip con explicación del cálculo proporcional
  const tooltipContent = (
    <Box sx={{ p: 0.5, maxWidth: 350 }}>
      <Typography variant="body2" fontWeight="bold" gutterBottom sx={{ color: '#fff' }}>
        Cálculo Proporcional (Prorrateo)
      </Typography>
      <Typography variant="body2" sx={{ color: '#fff' }}>
        Esta distribución aplica cálculo proporcional basado en el tiempo de
        tenencia de la inversión durante el periodo del batch.
      </Typography>
      <Typography variant="body2" sx={{ color: '#fff', mt: 1 }}>
        El rendimiento se calcula proporcionalmente considerando:
      </Typography>
      <Typography variant="body2" component="ul" sx={{ color: '#fff', pl: 2, my: 0.5 }}>
        <li>Fecha de inicio de la inversión</li>
        <li>Duración del periodo del batch</li>
        <li>Días efectivos de participación</li>
      </Typography>
    </Box>
  );

  return (
    <Tooltip title={tooltipContent} arrow placement="top">
      {chipComponent}
    </Tooltip>
  );
};

export default ProportionalCalculationIndicator;
